import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

import ColorInit from '../../helper/ColorInit';
import ScrollToTop from 'react-scroll-to-top';
import Preloader from '../../helper/Preloader';
// import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from '../../components/layout/HeaderHome';
import Breadcrumb from '../../components/seller-store/Breadcrumb';
// import BreadcrumbImage from "../../components/BreadcrumbImage";
import StoreHeaderImage from '../../components/seller-store/StoreHeaderImage';
import CategoryNav from '../../components/seller-store/CategoryNav';
import RecommendedProducts from '../../components/seller-store/RecommendedProducts';
import ProfileStore from '../../components/seller-store/ProfileStore';
import StoreProducts from '../../components/seller-store/StoreProducts';
import FooterOne from '../../components/layout/FooterOne';
import BottomFooter from '../../components/layout/BottomFooter';
import useJWT from '../../hooks/useJWT';
import useStoreInformation from '../../hooks/useStoreInformation';
import useProductCategory from '../../hooks/useProductCategory';

const SellerStorePage = () => {
    const { user, isLoggedIn } = useJWT();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [companyID, setCompanyID] = useState('');

    const config = JSON.parse(localStorage.getItem('user'));

    const { fetchStoreInformation, data: store, status: storeStatus, error: storeError } = useStoreInformation();

    const {
        fetchProductCategoryByShop,
        data: productCategory,
        status: productCategoryStatus,
        error: productCategoryError
    } = useProductCategory();

    useEffect(() => {
        document.title = 'iWant';
    }, []);

    useEffect(() => {
        // console.log("query", searchParams.has('storeid'))

        // Check if the specific query parameter is missing

        if (!searchParams.has('storeid')) {
            // Redirect the user to another page (e.g., the homepage or an error page)
            //navigate('/', { replace: true }); // Using replace: true prevents the original page from being in the browser history
            setCompanyID(config.companyId);

            if (!isLoggedIn) {
                // Not authenticated, redirect to login with redirect param
                navigate(
                    // `/login?redirect=${encodeURIComponent(`/product-details/${encodeURIComponent(product?.slug)}?variant=${selectedVariantId}`)}`
                    `/login?redirect=${encodeURIComponent(`/seller-store?storeid=${searchParams.has('storeid') !== '' ? searchParams.get('storeid') : ''}`)}`
                );
                // return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
            }
        } else {
            setCompanyID(searchParams.get('storeid'));

            if (!isLoggedIn) {
                // Not authenticated, redirect to login with redirect param
                navigate(
                    // `/login?redirect=${encodeURIComponent(`/product-details/${encodeURIComponent(product?.slug)}?variant=${selectedVariantId}`)}`
                    `/login?redirect=${encodeURIComponent(`/seller-store?storeid=${searchParams.has('storeid') !== '' ? searchParams.get('storeid') : ''}`)}`
                );
                // return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
            }
        }
    }, [searchParams, navigate]); // Depend on searchParams and navigate

    useEffect(() => {
        if (companyID && companyID !== '') {
            fetchStoreInformation(companyID);
            fetchProductCategoryByShop(companyID);
        }
    }, [companyID]);

    return (
        <>
            {/* ColorInit */}
            <ColorInit color={false} />

            {/* ScrollToTop */}
            <ScrollToTop smooth color="#990A02" />

            {/* Preloader */}
            <Preloader />

            {/* HeaderTwo */}
            {/* <HeaderOne /> */}
            <HeaderHome />

            {/* Breadcrumb */}
            <Breadcrumb title={'Store'} />

            <StoreHeaderImage storeId={companyID} store={store} />

            {/* <CategoryNav /> */}

            <RecommendedProducts store={store} storeId={companyID} productCategory={productCategory} />

            <ProfileStore storeId={companyID} store={store} />

            <StoreProducts storeId={companyID} productCategory={productCategory} />

            {/* FooterTwo */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default SellerStorePage;
